import { compose, flattenProp, withStateHandlers } from 'recompose';
import { injectIntl } from 'react-intl';
import { addProps, addIntlProps } from 'utils/recompose';
import { connect } from 'react-redux';
import {
  template,
  designPackageForTemplate,
  submittedTemplateQuantity,
  submittedTemplatePriority,
  charmsForTemplate,
} from 'reducers/templates/selectors';
import combineSelectors from 'utils/combineSelectors';
import formatCurrency from 'utils/formatCurrency';
import messages from './messages';
import { priceBands } from 'reducers/models/selectors';
import { mini } from 'reducers/dashboard/selectors';
import { differenceWith, isEqual } from 'lodash';

const mapStateToProps = combineSelectors({
  template,
  designPackageForTemplate,
  submittedTemplateQuantity,
  submittedTemplatePriority,
  priceBands,
  charmsForTemplate,
  mini,
});

export const priceBand = ({ priceBands, priceBandId }) =>
  priceBands.find(priceBand => priceBand.id === priceBandId);
export const priceBandMax = ({ priceBand }) => priceBand.max;
export const priceBandMin = ({ priceBand }) => priceBand.min;

const formattedTotal = formatCurrency({
  priceProp: 'totalPrice',
  currencyProp: 'currency',
});

const formattedDesignPrice = formatCurrency({
  priceProp: 'designPrice',
  currencyProp: 'currency',
});

const formattedPriceBandMax = formatCurrency({
  priceProp: 'priceBandMax',
  currencyProp: 'currency',
});

const formattedPriceBandMin = formatCurrency({
  priceProp: 'priceBandMin',
  currencyProp: 'currency',
});

export const formattedPriceBand = ({
  formattedPriceBandMin,
  formattedPriceBandMax,
  priceBand,
}) => {
  if (priceBand.max < 1000000) {
    return `${formattedPriceBandMin} - ${formattedPriceBandMax}`;
  } else {
    return `${formattedPriceBandMin}+`;
  }
};

export const renderSelection = ({ selectedDesignOption }) =>
  !!selectedDesignOption;
export const closeSelection = () => () => ({ selectedDesignOption: null });
export const onClickOrTouch = () => selectedDesignOption => ({
  selectedDesignOption,
});

const expand = ({ expanded }) => () => {
  return { expanded: !expanded };
};

const collapse = () => () => {
  return { expanded: false };
};

export const primaryOptions = () => [
  'paintOption',
  'interiorOption',
  'wheelOption',
];

export const secondaryOptions = ({
  primaryOptions,
  designPackageForTemplate,
}) => {
  return differenceWith(
    designPackageForTemplate.optionKeys,
    primaryOptions,
    isEqual,
  );
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['currency'],
  }),
  connect(mapStateToProps),
  flattenProp('template'),
  flattenProp('designPackageForTemplate'),
  withStateHandlers(
    { selectedDesignOption: null },
    { closeSelection, onClickOrTouch },
  ),
  withStateHandlers(
    { expanded: false },
    {
      expand,
      collapse,
    },
  ),
  addProps({
    priceBand,
  }),
  addProps({
    priceBandMax,
    priceBandMin,
    primaryOptions,
  }),
  addProps({
    formattedTotal,
    formattedDesignPrice,
    formattedPriceBandMax,
    formattedPriceBandMin,
    secondaryOptions,
  }),
  addProps({
    formattedPriceBand,
  }),
);
